import instObj from '@/backend/axios-instances'

const resource = "installations/summary"
const instance = instObj.baseInstance

export default {
  get(parameters) {
    return instance.get(resource, { params: parameters });
  }
}